import React from 'react';
import {
  Box,
  type GDSHeadingLevel,
  type GDSHeadingSize,
  HeadingText,
} from '@leagueplatform/genesis-core';
import {
  type MasonryEngineNode,
  type MasonryEngineNodeRendererProps,
  useIsAncestrallyHidden,
  HIDDEN_SUBTREE_CLASS_NAME,
} from '@leagueplatform/masonry-engine';
import { formatClassNames } from '../../../utils/format-masonry-class-name.util';

export type MasonryFlowStepProperties = {
  heading?: string;
  headingLevel?: GDSHeadingLevel;
  headingSize?: GDSHeadingSize;
};

export type MasonryFlowStepItems = {
  items: MasonryEngineNode[];
};

export type MasonryFlowStep = MasonryEngineNode<
  'linearFlowStep',
  MasonryFlowStepProperties,
  {},
  MasonryFlowStepItems
>;

export type MasonryFlowStepRendererProps =
  MasonryEngineNodeRendererProps<MasonryFlowStep>;

export const MasonryFlowStepRenderer = ({
  heading,
  headingLevel = '3',
  headingSize = 'lg',
  items,
  className,
  engineClassName,
  rootElementRef,
  locatorId,
  css,
}: MasonryFlowStepRendererProps) => {
  const isHidden = useIsAncestrallyHidden();
  return (
    <Box
      css={css}
      data-testid={locatorId}
      ref={rootElementRef}
      className={formatClassNames(
        engineClassName,
        className,
        isHidden ? HIDDEN_SUBTREE_CLASS_NAME : '',
      )}
    >
      {heading && (
        <HeadingText level={headingLevel} size={headingSize}>
          {heading}
        </HeadingText>
      )}
      {items}
    </Box>
  );
};
